import { defineComponent as o, createBlock as p, openBlock as i, unref as l, withCtx as t, renderSlot as a, createTextVNode as n, createElementVNode as u } from "vue";
import { ScalarSearchResultItem as d } from "@scalar/components";
const c = ["innerHTML"], S = /* @__PURE__ */ o({
  __name: "TypesenseSearchResult",
  props: {
    snippet: {}
  },
  setup(r) {
    return (s, e) => (i(), p(l(d), { icon: "DocsPage" }, {
      description: t(() => [
        e[0] || (e[0] = n(" …", -1)),
        u("span", {
          class: "guides-search-results-snippet",
          innerHTML: r.snippet
        }, null, 8, c),
        e[1] || (e[1] = n("… ", -1))
      ]),
      default: t(() => [
        a(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
});
export {
  S as default
};
